$(function() {

    var $document = $(document);

    // stop clickthrough on root page so the megamenu opens

    $document.on('click', '.megamenu', function(e) {
        e.stopPropagation();
    });


    // search overlay trigger

    $('#overlaySearch').on('shown.bs.modal', function() {
        $('#overlaySearchInput').trigger('focus');
    });

    // lighbox overlay trigger

    $document.on('click', 'a.lightbox', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            $('#overlayPreviewContent').html('<img src="'+url+'" class="img-fluid">');
        }
    });

    // share overlay trigger

    $document.on('click', '#pageShare .popup a', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var newWindow = window.open(url, 'Share', 'scrollbars=yes, width=1024, height=660');
            if (window.focus) {
                newWindow.focus();
            }
        }
    });

    // fix widows

    var widowElements = [
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'p.subHeading',
        'p.lead',
        'blockquote p',
        '.link a'
    ];

    $.each(widowElements, function(indexTag, elemTag) {
        $(elemTag).each(function(indexItem, elemItem) {
            var text = widont($(elemItem).html());
            $(elemItem).html(text);
        });
    });

	$("body").addClass("startAnimation");

	AOS.init();


    function exportTableToCSV($table, filename) {

    var $rows = $table.find('tr:has(td)'),

      // Temporary delimiter characters unlikely to be typed by keyboard
      // This is to avoid accidentally splitting the actual contents
      tmpColDelim = String.fromCharCode(11), // vertical tab character
      tmpRowDelim = String.fromCharCode(0), // null character

      // actual delimiter characters for CSV format
      colDelim = '","',
      rowDelim = '"\r\n"',

      // Grab text from table into CSV formatted string
      csv = '"' + $rows.map(function(i, row) {
        var $row = $(row),
          $cols = $row.find('td');

        return $cols.map(function(j, col) {
          var $col = $(col),
            text = $col.text();

            //return text.replace(/"/g, '""'); // escape double quotes
           // return text.replace(/\t+/g, ''); // Trim ALL Whitespace
            return text.replace(/[\n\r\s\t]+/g, ' ');




        }).get().join(tmpColDelim);




      }).get().join(tmpRowDelim)
      .split(tmpRowDelim).join(rowDelim)
      .split(tmpColDelim).join(colDelim) + '"';

    // Deliberate 'false', see comment below
    if (false && window.navigator.msSaveBlob) {

      var blob = new Blob([decodeURIComponent(csv)], {
        type: 'text/csv;charset=utf8'
      });

      // Crashes in IE 10, IE 11 and Microsoft Edge
      // See MS Edge Issue #10396033
      // Hence, the deliberate 'false'
      // This is here just for completeness
      // Remove the 'false' at your own risk
      window.navigator.msSaveBlob(blob, filename);

    } else if (window.Blob && window.URL) {
      // HTML5 Blob        
      var blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8'
      });
      var csvUrl = URL.createObjectURL(blob);

      $(this)
        .attr({
          'download': filename,
          'href': csvUrl
        });
    } else {
      // Data URI
      var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csv);

      $(this)
        .attr({
          'download': filename,
          'href': csvData,
          'target': '_blank'
        });
    }
  }// end of function exportTableToCSV


  // This must be a hyperlink
  $(".export").on('click', function(event) {
    // CSV
    var dt = new Date();
    var timestamp = dt.getFullYear() + "-"
                  + (dt.getMonth()+1) + "-" 
                  + dt.getDate() + "_" 
                  + dt.getHours() + "-" 
                  + dt.getMinutes() + "-" 
                  + dt.getSeconds();
    var className = [$('#dvData').attr('class')];
    var args = [$('#dvData>table'), ''+className+'-export_'+timestamp+'.csv'];

    exportTableToCSV.apply(this, args);

    // If CSV, don't do event.preventDefault() or return false
    // We actually need this to be a typical hyperlink
  });

  var applicationFormPosition = $('#application-form').offset();

  $( ".js-jump-button" ).click(function() {
    $('html, body').animate({scrollTop: applicationFormPosition.top}, "slow");
  });

});

// // to test if jquery is working
// window.onload = function() {
//     if (window.jQuery) {  
//         // jQuery is loaded  
//         alert("Yeah!");
//     } else {
//         // jQuery is not loaded
//         alert("Doesn't Work");
//     }
// }
